'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cssifySupportRules;

var _objectReduce = require('fast-loops/lib/objectReduce');

var _objectReduce2 = _interopRequireDefault(_objectReduce);

var _generateCSSSupportRule = require('./generateCSSSupportRule');

var _generateCSSSupportRule2 = _interopRequireDefault(_generateCSSSupportRule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function cssifySupportRules(supportRules) {
  return (0, _objectReduce2.default)(supportRules, function (css, cssRules, support) {
    if (cssRules.length > 0) {
      css += (0, _generateCSSSupportRule2.default)(support, cssRules);
    }

    return css;
  }, '');
}